<template>
  <EmbedPlayer />
</template>

<script>
import EmbedPlayer from 'components/embedplayer/EmbedPlayer'
import { event } from 'utils'

export default {
  name: 'EmbedPlayerIframe',
  components: {
    EmbedPlayer,
  },
  mounted () {
    if (this.$route.params.episodeId) {
      event.$emit('showEmbedPlayer', this.$route.params.episodeId, this.$route.query.access_key)
    } else if (this.$route.params.podcastId) {
      event.$emit('showEmbedArchivePlayer', this.$route.params.podcastId, this.$route.query.access_key)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/embed-player/IframeEmbedPlayer.vue